<template>
  <div>
    <audio
      controls="controls"
      hidden
      src="../../../assets/err.mp3"
      ref="erraudio"
    ></audio>
    <audio
      controls="controls"
      hidden
      src="../../../assets/success.wav"
      ref="successaudio"
    ></audio>

    <div class="item-info">
      <ul class="item-ul" v-for="(item, index) in info1" :key="index">
        <li class="item-li">
          <div class="item-left">
            <span>发货编码</span><span>{{ item.sourceNo }}</span>
          </div>
          <div class="item-right">
            <span>品牌</span><span>{{ item.brand }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-right">
            <span>SKU名称</span><span>{{ item.productNameCN }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>调入仓</span><span>{{ item.warehouseName }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>是否带电</span><span>{{ item.isElectricityText }}</span>
          </div>
          <div class="item-right">
            <span>是否退税</span><span>{{ item.isReturnTaxText }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>型号</span><span>{{ item.model }}</span>
          </div>
          <div class="item-right">
            <span style="white-space: nowrap; padding-right: 15px"
              >shipmentid</span
            ><span>{{ item.shipmentID }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>FNSKU</span><span>{{ item.fnsku }}</span>
          </div>
          <div class="item-right">
            <span>{{ item.barMarkDoHandle }}</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="conventionalBox-info" v-if="info2.length">
      <p class="p-title">常规箱信息</p>
      <div v-for="(item, index) in info2" :key="index">
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">箱号</van-col>
          <van-col span="6">单箱数量</van-col>
          <van-col span="6">件数</van-col>
          <van-col span="6">总数量</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6" class="other-cell"
            >{{ item.startBoxNo }}-{{ item.endBoxNo }}</van-col
          >
          <van-col span="6" class="other-cell">{{ item.singleBoxQty }}</van-col>
          <van-col span="6" class="other-cell">{{ item.boxCount }}</van-col>
          <van-col span="6" class="other-cell">{{ item.totalBoxQty }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">长宽高(cm)</van-col>
          <van-col span="18" class="other-cell txt-left"
            >{{ item.boxLength }}*{{ item.boxWidth }}*{{
              item.boxHeight
            }}</van-col
          >
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">重量(kg)</van-col>
          <van-col span="18" class="other-cell txt-left">{{
            item.boxWeight
          }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6" style="line-height: 30px"
            >体积(cm<sup>3</sup>)</van-col
          >
          <van-col span="18" class="other-cell txt-left">{{
            item.volume
          }}</van-col>
        </van-row>
      </div>
    </div>

    <div class="conventionalBox-info" v-if="info3.length">
      <p class="p-title">混箱信息</p>
      <div v-for="(item, index) in info3" :key="index">
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">箱号</van-col>
          <van-col span="6">单箱数量</van-col>
          <van-col span="6">件数</van-col>
          <van-col span="6">总数量</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6" class="other-cell">{{ item.startBoxNo }}</van-col>
          <van-col span="6" class="other-cell">{{ item.singleBoxQty }}</van-col>
          <van-col span="6" class="other-cell">{{ item.boxCount }}</van-col>
          <van-col span="6" class="other-cell">{{ item.totalBoxQty }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">长宽高(cm)</van-col>
          <van-col span="18" class="other-cell txt-left"
            >{{ item.boxLength }}*{{ item.boxWidth }}*{{
              item.boxHeight
            }}</van-col
          >
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">重量(kg)</van-col>
          <van-col span="6" class="other-cell">{{ item.boxWeight }}</van-col>
          <van-col span="6" style="line-height: 30px"
            >体积(cm<sup>3</sup>)</van-col
          >
          <van-col span="6" class="other-cell">{{ item.volume }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">混箱SKU</van-col>
          <van-col
            span="18"
            class="other-cell txt-left"
            :style="{
              'font-size': item.boxDetail.length > 1 ? '12px' : '15px',
              'white-space': 'nowrap',
            }"
          >
            <span v-for="(itemD, indexD) in item.boxDetail" :key="indexD"
              >{{ itemD.sku }}({{ itemD.qty }})</span
            >
          </van-col>
        </van-row>
      </div>
    </div>

    <div class="conventionalBox-info" v-if="info4.length">
      <p class="p-title">尾箱信息</p>
      <div v-for="(item, index) in info4" :key="index">
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">箱号</van-col>
          <van-col span="6">单箱数量</van-col>
          <van-col span="6">件数</van-col>
          <van-col span="6">总数量</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6" class="other-cell">{{ item.startBoxNo }}</van-col>
          <van-col span="6" class="other-cell">{{ item.singleBoxQty }}</van-col>
          <van-col span="6" class="other-cell">{{ item.boxCount }}</van-col>
          <van-col span="6" class="other-cell">{{ item.totalBoxQty }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">长宽高(cm)</van-col>
          <van-col span="18" class="other-cell txt-left"
            >{{ item.boxLength }}*{{ item.boxWidth }}*{{
              item.boxHeight
            }}</van-col
          >
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">重量(kg)</van-col>
          <van-col span="6" class="other-cell">{{ item.boxWeight }}</van-col>
          <van-col span="6" style="line-height: 30px"
            >体积(cm<sup>3</sup>)</van-col
          >
          <van-col span="6" class="other-cell">{{ item.volume }}</van-col>
        </van-row>
      </div>
    </div>
    <div style="white-space: nowrap">
      <textarea
        style="width: 94%; margin: 2%"
        placeholder="备注"
        maxlength="200"
        v-model="remark"
      ></textarea>
    </div>
    <div class="photo">
      <div class="sign-photo-cpntent">
        <div class="sign-photo-box">
          <ul>
            <div>
              <p>FBA条码照片</p>
              <div class="sign-photo-item" v-if="imgObj.fbaImageUrl">
                <span class="delete-icon" @click="deleteImg('fbaImageUrl')"
                  >x</span
                >
                <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                <img
                  :src="imgObj.fbaImageUrl"
                  class="sign-photo-item-img"
                  alt=""
                  @click="previewImage(imgObj.fbaImageUrl)"
                />
              </div>

              <div class="sign-photo-btn" v-else>
                <div class="photo">
                  <input
                    class="img hidden"
                    @change="changeImg"
                    type="file"
                    name="cover"
                    ref="inputer"
                    accept="image/*"
                  />
                  <p @click="chooseImage(0)">
                    <i class="el-icon-camera"></i>
                  </p>
                </div>
              </div>
            </div>

            <div>
              <p>箱唛照片</p>
              <div class="sign-photo-item" v-if="imgObj.cartonLabelImageUrl">
                <span
                  class="delete-icon"
                  @click="deleteImg('cartonLabelImageUrl')"
                  >x</span
                >
                <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                <img
                  :src="imgObj.cartonLabelImageUrl"
                  class="sign-photo-item-img"
                  alt=""
                  @click="previewImage(imgObj.cartonLabelImageUrl)"
                />
              </div>

              <div class="sign-photo-btn" v-else>
                <div class="photo">
                  <input
                    class="img hidden"
                    @change="changeImg"
                    type="file"
                    name="cover"
                    ref="inputer"
                    accept="image/*"
                  />
                  <p @click="chooseImage(1)">
                    <i class="el-icon-camera"></i>
                  </p>
                </div>
              </div>
            </div>
          </ul>
        </div>

        <!-- <div class="sign-photo-save">
                    <button class="submit-btn" @click="submit">保存</button>
                </div> -->
      </div>
    </div>

    <div class="submit-box" v-if="$route.query.tabType != '待装车'">
      <button class="submit-btn" @click="submit">确认无误</button>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
  ImagePreview,
} from "vant";
import { getLabelingDetail, addLabeling } from "@/api/mobile/labeling_api";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
import { BaseApiUrl } from "@/api/axios_config";
import axios from "axios";
export default {
  data() {
    return {
      list: {},
      info1: {},
      info2: {},
      info3: {},
      info4: {},
      imgObj: { fbaImageUrl: "", cartonLabelImageUrl: "" },
      imgType: 0,
      imgFiles: [],
      saveImgUrlArr: [],
      remark: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.name]: ImagePreview,
    [Field.name]: Field,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({}),

    init() {
      this.getDetail();
    },

    getDetail() {
      const { shippingPlanDetailID, stockingTaskID } = this.$route.query;

      const data = {
        shippingPlanDetailID,
        stockingTaskID,
      };

      getLabelingDetail(data).then((res) => {
        if (res.status === 200) {
          const { taskDetail, wholeCase, mixingTank, theTrunk, imgUrlList } =
            res.response;
          this.info1 = taskDetail;
          this.info2 = wholeCase;
          this.info3 = mixingTank;
          this.info4 = theTrunk;
          if (taskDetail.length > 0) {
            this.remark = taskDetail[0].remark;
          }

          if (imgUrlList && imgUrlList.length) {
            imgUrlList.forEach((item, i) => {
              if (item.labelingType === 1) {
                this.$set(
                  this.imgObj,
                  "fbaImageUrl",
                  `data:image/jpg;base64,${item.urlPath}`
                );
                this.saveImgUrlArr.push({
                  imageUrl: item.imgUrl,
                  labelingType: 1,
                });
              }
              if (item.labelingType === 2) {
                this.$set(
                  this.imgObj,
                  "cartonLabelImageUrl",
                  `data:image/jpg;base64,${item.urlPath}`
                );
                this.saveImgUrlArr.push({
                  imageUrl: item.imgUrl,
                  labelingType: 2,
                });
              }
            });
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    checkBoxCodeImg() {
      if (!this.saveImgUrlArr.length) return false;

      let flag = false;
      this.saveImgUrlArr.forEach((item, i) => {
        if (item.labelingType === 2) {
          flag = true;
        }
      });
      if (!flag) return false;
      return true;
    },
    showsound(isSuccess) {
      if (isSuccess) {
        this.$refs.successaudio.currentTime = 0;
        this.$refs.successaudio.play();
      } else {
        this.$refs.erraudio.currentTime = 0;
        this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      const { shippingPlanDetailID } = this.$route.query;
      const { stockingTaskID } = this.info1[0];

      const data = {
        StockingTaskID: stockingTaskID,
        shippingPlanDetailID,
        labelingUrl: this.saveImgUrlArr,
        Remark: that.remark,
      };

      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      addLabeling(data).then((res) => {
        if (res.status === 200) {
          this.showsound(true);
          Toast.success("提交成功");

          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },

    deleteImg(type) {
      this.$set(this.imgObj, type, "");

      this.saveImgUrlArr.forEach((item, i) => {
        if (type == "fbaImageUrl" && item.labelingType === 1) {
          // FBA
          this.saveImgUrlArr.splice(i, 1);
        }

        if (type == "cartonLabelImageUrl" && item.labelingType === 2) {
          this.saveImgUrlArr.splice(i, 1);
        }
      });
    },

    changeImg() {
      const img = document.getElementsByClassName("img")[0];

      if (!img.files.length) return;

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.submitImg();
    },

    chooseImage(type) {
      this.imgType = type;
      document.getElementsByClassName("img")[0].click();
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;

      var file = files;

      const { type, name } = file[0];

      var imageType = /^image\//;
      if (!imageType.test(type)) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        that.$set(
          that.imgObj,
          that.imgType === 0 ? "fbaImageUrl" : "cartonLabelImageUrl",
          e.target.result
        );
      };
      reader.readAsDataURL(file[0]);
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push({
            imageUrl: res.data.response[0].urlPath,
            labelingType: this.imgType === 0 ? 1 : 2,
          });
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    padding-left: 18.5%;
    .item-li {
      display: flex;
      align-content: flex-start;
      word-break: break-all;
      margin-bottom: 4px;
      padding-bottom: 4px;
      & > div {
        flex: 1;
        line-height: 25px;
        max-width: 100%;
        display: flex;
        & > span {
          vertical-align: text-top;
          &:first-child {
            text-align: start;
            padding-right: 10px;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
@media (max-width: 450px) {
  .item-info {
    font-size: 12px;
    .item-ul {
      padding: 0 2%;
      .item-li {
        .item-right {
          margin-left: 3%;
        }
        & > div {
          line-height: 22px;
          & > span {
            &:first-child {
              padding-right: 6px;
            }
            &:last-child {
              flex: 1;
            }
          }
        }
      }
    }
  }
}
.conventionalBox-info {
  font-size: 14px;
  border-bottom: 1px solid #cccccc;
}
.sign-photo-save {
  padding: 0 10px;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
  font-size: 14px;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  border-right: 1px solid #cccccc;
  border-top: 1px solid #cccccc;
  // border-bottom: 1px solid #cccccc;
  &:last-child {
    border-right: 0;
  }
}
.other-cell {
  background-color: #fff !important;
}
.txt-left {
  padding-left: 10px;
  text-align: left !important;
}
.submit-box {
  position: static;
  padding: 20px 0;
  .submit-btn {
    margin-bottom: 10px;
  }
}
.sign-photo-box {
  margin: 5px 10px 10px;
  box-sizing: border-box;
  padding: 10px;
  height: 170px;
  ul {
    display: flex;
    & > div {
      &:first-child {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      &:last-child {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      p {
        font-size: 13px;
      }
    }
    .sign-photo-item {
      width: 100px;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;
      box-shadow: 0px 0px 7px -1px #cccccc;
      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }
      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }
    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 100px;
      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;
        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;
          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
</style>